export interface OddFilterDTO {
  FromTime: string;
  ToTime: string;
  MarketType?: MarketType | number;
  SportType: SportType;
  TeamID: number;
  BetTypes: BetType[];
  LeagueID?: number[];
  sort?: string[];
  Dates?: string[];
  TimeZone?: string;
  MarketFilter?: string;
  Lang: string;
  SearchKey?: string;
  SearchLanguageType?: 'ALL' | 'TEAM' | 'LEAGUE';
}

export enum SportType {
  S = 'S',
  BB = 'BB',
  FS = 'FS',
  BC = 'BC',
  UF = 'UF',
  BE = 'BE',
  IH = 'IH',
  TN = 'TN',
  FB = 'FB',
  BA = 'BA',
  GF = 'GF',
  CK = 'CK',
  VB = 'VB',
  HB = 'HB',
  PL = 'PL',
  BL = 'BL',
  NS = 'NS',
  RB = 'RB',
  GP = 'GP',
  DT = 'DT',
  BX = 'BX',
  AT = 'AT',
  AR = 'AR',
  CH = 'CH',
  DV = 'DV',
  EQ = 'EQ',
  ET = 'ET',
  CN = 'CN',
  CS = 'CS',
  CY = 'CY',
  HK = 'HK',
  GM = 'GM',
  FL = 'FL',
  NT = 'NT',
  OL = 'OL',
  OT = 'OT',
  PO = 'PO',
  QQ = 'QQ',
  MN = 'MN',
  RU = 'RU',
  TT = 'TT',
  WG = 'WG',
  WI = 'WI',
  WP = 'WP',
  WS = 'WS',
  ES = 'ES',
  MT = 'MT',
}

export enum MarketType {
  All = 0,
  Early = 1,
  Today = 2,
  Live = 3,
}

export enum BetType {
  HDP = 'HDP',
  OU = 'OU',
  OE = 'OE',
  X12 = 'X12',
  DC = 'DC',
  CS = 'CS',
  HTFT = 'HTFT',
  FGLG = 'FGLG',
  TG = 'TG',
  OUT = 'OUT',
  HP3 = 'HP3',
  ATG = 'ATG',
  HTG = 'HTG',
  ETG = 'ETG',
  PAR = 'PAR',
  CNS = 'CNS',
  H1ETG = 'H1ETG',
}

export interface OddDTO {
  MatchGroupID: string;
  MatchID: number;
  MarketType: number;
  LeagueID: number;
  LeagueName: string;
  SportType: SportType;
  HomeTeamID: number;
  HomeTeamName: string;
  HomeImgUrl: string;
  AwayTeamID: number;
  AwayTeamName: string;
  AwayImgUrl: string;
  MatchDate: number;
  StartDate: number;
  IsDefaultMatch: boolean;
  IsSpecial: boolean;
  IsNuetral: boolean;
  SpecialID: number;
  IsET: boolean;
  AllowParlay: boolean;
  AllowParlay2Selection: boolean;
  AllowCashout: boolean;
  Pen: number;
  Ot: number;
  Period: number;
  IsRunning: boolean;
  AllowBet: boolean;
  WorkingDate: number;
  MatchFlag: number;
  HomeTeamScore: number;
  AwayTeamScore: number;
  HomeTeamRC: number;
  AwayTeamRC: number;
  IsHomeGiveFT: boolean;
  IsHomeGiveFH: boolean;
  IsPause: boolean;
  IsDanger: boolean;
  IsNeutral: boolean;
  IsDeleted: boolean;
  IsLiveStatic: boolean;
  IsLiveCenter: boolean;
  TvLink: string;
  LiveDisplay: string;
  HomeColor: string;
  AwayColor: string;
  HDP_List: {
    HDP_SpecialValue_FT: string;
    HDP_HomeTeam_OddsValue_FT: {
      MY_A: number;
    };
    HDP_AwayTeam_OddsValue_FT: {
      MY_A: number;
    };
    HDP_HomeTeam_OddsValue_FT_Parlay: {};
    HDP_AwayTeam_OddsValue_FT_Parlay: {};
    HDP_SpecialValue_FH: string;
    HDP_HomeTeam_OddsValue_FH: {
      MY_A: number;
    };
    HDP_AwayTeam_OddsValue_FH: {
      MY_A: number;
    };
    HDP_HomeTeam_OddsValue_FH_Parlay: {};
    HDP_AwayTeam_OddsValue_FH_Parlay: {};
    OddsID: number;
    IsHide: boolean;
    IsHomeGiveFH: boolean;
    IsHomeGiveFT: boolean;
    MatchID: number;
  }[];
  OU_List: {
    OU_SpecialValue_FT: string;
    OU_OddsValue_Over_FT: {
      MY_A: number;
    };
    OU_OddsValue_Under_FT: {
      MY_A: number;
    };
    OU_OddsValue_Over_FT_Parlay: {};
    OU_OddsValue_Under_FT_Parlay: {};
    OU_SpecialValue_FH: string;
    OU_OddsValue_Over_FH: {
      MY_A: number;
    };
    OU_OddsValue_Under_FH: {
      MY_A: number;
    };
    OU_OddsValue_Over_FH_Parlay: {};
    OU_OddsValue_Under_FH_Parlay: {};
    OddsID: number;
    IsHide: boolean;
    IsHomeGiveFH: boolean;
    IsHomeGiveFT: boolean;
    MatchID: number;
  }[];
  X12: {
    X12_OddsValue_1_FT: number;
    X12_OddsValue_X_FT: number;
    X12_OddsValue_2_FT: number;
    X12_OddsValue_1_FT_Parlay: number;
    X12_OddsValue_X_FT_Parlay: number;
    X12_OddsValue_2_FT_Parlay: number;
    X12_OddsValue_1_FH: number;
    X12_OddsValue_X_FH: number;
    X12_OddsValue_2_FH: number;
    X12_OddsValue_1_FH_Parlay: number;
    X12_OddsValue_X_FH_Parlay: number;
    X12_OddsValue_2_FH_Parlay: number;
    DC_1X_FT: number;
    DC_12_FT: number;
    DC_X2_FT: number;
    OddsID: number;
    IsHide: boolean;
  };
  CS: {
    C00_FT: number;
    C01_FT: number;
    C02_FT: number;
    C03_FT: number;
    C04_FT: number;
    C10_FT: number;
    C11_FT: number;
    C12_FT: number;
    C13_FT: number;
    C14_FT: number;
    C20_FT: number;
    C21_FT: number;
    C22_FT: number;
    C23_FT: number;
    C24_FT: number;
    C30_FT: number;
    C31_FT: number;
    C32_FT: number;
    C33_FT: number;
    C34_FT: number;
    C40_FT: number;
    C41_FT: number;
    C42_FT: number;
    C43_FT: number;
    C44_FT: number;
    AOS_FT: number;
    AOS_Excluding_FT: string;
    AOSCores_FT: number;
    C00_FH: number;
    C01_FH: number;
    C02_FH: number;
    C03_FH: number;
    C10_FH: number;
    C11_FH: number;
    C12_FH: number;
    C13_FH: number;
    C20_FH: number;
    C21_FH: number;
    C22_FH: number;
    C23_FH: number;
    C30_FH: number;
    C31_FH: number;
    C32_FH: number;
    C33_FH: number;
    AOS_FH: number;
    AOS_Excluding_FH: string;
    AOSCores_FH: number;
    OddsID: number;
    IsHide: boolean;
  };
  OE: {
    OE_Odd_FT: {
      MY_A: number;
    };
    OE_Even_FT: {
      MY_A: number;
    };
    OE_Odd_FT_Parlay: {};
    OE_Even_FT_Parlay: {};
    OE_Odd_FH: {
      MY_A: number;
    };
    OE_Even_FH: {
      MY_A: number;
    };
    OE_Odd_FH_Parlay: {};
    OE_Even_FH_Parlay: {};
    OddsID: number;
    IsHide: boolean;
  };
  TG: {
    TG_01_FT: number;
    TG_23_FT: number;
    TG_46_FT: number;
    TG_7UP_FT: number;
    OddsID: number;
    IsHide: boolean;
  };
  FGLG: {
    FG_HomeTeam_FT: number;
    FG_AwayTeam_FT: number;
    LG_HomeTeam_FT: number;
    LG_AwayTeam_FT: number;
    FGLG_NoGoal_FT: number;
    OddsID: number;
    IsHide: boolean;
  };
  HTFT: {
    HTFT_AA: number;
    HTFT_AD: number;
    HTFT_AH: number;
    HTFT_DA: number;
    HTFT_DD: number;
    HTFT_DH: number;
    HTFT_HA: number;
    HTFT_HD: number;
    HTFT_HH: number;
    OddsID: number;
    IsHide: boolean;
  };
  Outright: {
    Outright_Home_FT: number;
    OddsID: number;
    IsHide: boolean;
  };
  HP3: {
    HP3_Home: number;
    HP3_Draw: number;
    HP3_Away: number;
    OddsID: number;
    IsHide: boolean;
  };
  CNS: {
    CNS_HomeYes: number;
    CNS_HomeNo: number;
    CNS_AwayYes: number;
    CNS_AwayNo: number;
    OddsID: number;
    IsHide: boolean;
  };
  ATG: {
    ATG_0: number;
    ATG_1: number;
    ATG_2: number;
    ATG_3Up: number;
    OddsID: number;
    IsHide: boolean;
  };
  HTG: {
    HTG_0: number;
    HTG_1: number;
    HTG_2: number;
    HTG_3Up: number;
    OddsID: number;
    IsHide: boolean;
  };
  ETG: {
    ETG_0: number;
    ETG_1: number;
    ETG_2: number;
    ETG_3: number;
    ETG_4: number;
    ETG_5: number;
    ETG_6Up: number;
    OddsID: number;
    IsHide: boolean;
  };
  H1ETG: {
    H1ETG_0: number;
    H1ETG_1: number;
    H1ETG_2: number;
    H1ETG_3Up: number;
    OddsID: number;
    IsHide: boolean;
  };
  OddsDetailsCount: number;
  SpecialOdds?: {
    CORNERS: OddDTO[];
  };
}

export interface OddsResponseDTO {
  data: OddDTO[];
  version: number;
}

export interface GetUserFavoritesDTO {
  Metadata: Record<SportType, number[]>;
  Details: Record<SportType, OddDTO[]>;
}

export interface HotEventDTO {
  MatchGroupID: string;
  MatchID: number;
  MatchDate: string;
  MarketType: number;
  SportType: string;
  SportName: string;
  LeagueID: number;
  LeagueName: string;
  HomeTeamID: number;
  HomeTeamName: string;
  HomeImgUrl: string;
  AwayTeamID: number;
  AwayTeamName: string;
  AwayImgUrl: string;
  MatchPeriod: string;
  HomeScore: string;
  AwayScore: string;
  HomeRedCard: string;
  AwayRedCard: string;
  HDP_SpecialValue_FT: string;
  MY_HDP_OddsValue_Home_FT: string;
  HK_HDP_OddsValue_Home_FT: string;
  DE_HDP_OddsValue_Home_FT: string;
  ID_HDP_OddsValue_Home_FT: string;
  US_HDP_OddsValue_Home_FT: string;
  MY_HDP_OddsValue_Away_FT: string;
  HK_HDP_OddsValue_Away_FT: string;
  DE_HDP_OddsValue_Away_FT: string;
  ID_HDP_OddsValue_Away_FT: string;
  US_HDP_OddsValue_Away_FT: string;
  OU_SpecialValue_FT: string;
  MY_OU_OddsValue_Home_FT: string;
  HK_OU_OddsValue_Home_FT: string;
  DE_OU_OddsValue_Home_FT: string;
  ID_OU_OddsValue_Home_FT: string;
  US_OU_OddsValue_Home_FT: string;
  MY_OU_OddsValue_Away_FT: string;
  HK_OU_OddsValue_Away_FT: string;
  DE_OU_OddsValue_Away_FT: string;
  ID_OU_OddsValue_Away_FT: string;
  US_OU_OddsValue_Away_FT: string;
  X12_OddsValue_1_FT: string;
  X12_OddsValue_X_FT: string;
  X12_OddsValue_2_FT: string;
  HDP_SpecialValue_FH: string;
  MY_HDP_OddsValue_Home_FH: string;
  HK_HDP_OddsValue_Home_FH: string;
  DE_HDP_OddsValue_Home_FH: string;
  ID_HDP_OddsValue_Home_FH: string;
  US_HDP_OddsValue_Home_FH: string;
  MY_HDP_OddsValue_Away_FH: string;
  HK_HDP_OddsValue_Away_FH: string;
  DE_HDP_OddsValue_Away_FH: string;
  ID_HDP_OddsValue_Away_FH: string;
  US_HDP_OddsValue_Away_FH: string;
  OU_SpecialValue_FH: string;
  MY_OU_OddsValue_Home_FH: string;
  HK_OU_OddsValue_Home_FH: string;
  DE_OU_OddsValue_Home_FH: string;
  ID_OU_OddsValue_Home_FH: string;
  US_OU_OddsValue_Home_FH: string;
  MY_OU_OddsValue_Away_FH: string;
  HK_OU_OddsValue_Away_FH: string;
  DE_OU_OddsValue_Away_FH: string;
  ID_OU_OddsValue_Away_FH: string;
  US_OU_OddsValue_Away_FH: string;
  X12_OddsValue_1_FH: string;
  X12_OddsValue_X_FH: string;
  X12_OddsValue_2_FH: string;
  MatchUrl_For_ClassicEdition: string;
  MatchUrl_For_AsianEdition: string;
  OddsDetailsCount: number;
  HomeGiveFT: boolean;
}

export interface LeagueDTO {
  LeagueID: number;
  LeagueName: string;
  MatchCount: number;
}

export interface TeamLeagueSearch {
  i: number;
  t: string;
  v: string;
}

export enum TeamLeagueType {
  LEAGUE_NAME = 'LEAGUE_NAME',
  TEAM_NAME = 'TEAM_NAME',
  SPECIAL_NAME = 'SPECIAL_NAME',
}
